<agr-form-dialog [formGroup]="formGroup" [data]="data" (confirm)="confirm()" (cancel)="cancel()" (alt)="alt()">
  <div class="flex--container" class="treatment-container">
    <h2>{{ 'adviceDetails' | translate }}</h2>
    @if (isGbmTreatment()) {
      <div class="notification notification-warning layout--margin-horizontal">
        <mat-icon>warning</mat-icon>
        <strong class="text--warning" [innerHTML]="'gbmWarningTitle' | translate"></strong>
        <br />
        <span [innerHTML]="'gbmWarningDescription' | translate"></span>
      </div>
    }
    <div class="flex--row flex--gutter">
      <div class="flex__child">
        <mat-form-field class="full-width-field">
          <mat-label>{{ 'name' | translate }}</mat-label>

          <input
            matInput
            formControlName="name"
            [placeholder]="'name' | translate"
            class="input-disabled"
            readonly
            data-test="editTreatment-name"
          />
        </mat-form-field>
      </div>
    </div>
    <div class="flex--row flex--gutter">
      <div class="flex__child">
        <mat-form-field class="full-width-field">
          <mat-label>{{ 'objective' | translate }}</mat-label>

          <input
            matInput
            formControlName="objective"
            [placeholder]="'objective' | translate"
            class="input-disabled"
            readonly
            data-test="editTreatment-name"
          />
        </mat-form-field>
      </div>
    </div>
    <div class="flex--row flex--gutter">
      <div class="flex__child">
        <mat-form-field class="full-width-field">
          <mat-label>{{ 'frequency' | translate }}</mat-label>

          <input
            matInput
            agrNumber
            formControlName="frequency"
            [step]="1"
            autocomplete="off"
            class="input-disabled"
            readonly
            data-test="editTreatment-frequency"
          />
        </mat-form-field>
      </div>
      @if (isGbmTreatment()) {
        <div class="flex__child">
          <mat-form-field class="full-width-field">
            <mat-label>{{ 'driftReduction' | translate }}</mat-label>
            <input
              matInput
              agrNumber
              formControlName="driftReduction"
              [step]="1"
              autocomplete="off"
              class="input-disabled"
              readonly
              data-test="editTreatment-driftReduction"
            />
          </mat-form-field>
        </div>
      }
    </div>
    <div class="flex--row flex--gutter">
      <div class="flex__child">
        <div class="mat-slide-group">
          <mat-slide-toggle
            color="primary"
            formControlName="shouldUseAreaInHectaresManual"
            class="input-disabled"
            readonly
            data-test="edit-cropfield-shouldUseAreaInHectaresManual"
            >{{ 'shouldUseAreaInHectaresManual' | translate }}
          </mat-slide-toggle>
        </div>
      </div>
      <div class="flex__child">
        <mat-form-field class="full-width-field">
          <mat-label>{{ 'hectare' | translate }}</mat-label>

          <input
            matInput
            agrNumber
            maxlength="7"
            formControlName="areaInHectaresManual"
            [min]="0"
            [step]="0.01"
            class="input-disabled"
            readonly
            data-test="editTreatment-areaInHectaresManual"
          />
        </mat-form-field>
      </div>
    </div>
    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'moment' | translate }}</mat-label>

        <textarea
          matInput
          formControlName="moment"
          [cdkTextareaAutosize]="true"
          [cdkAutosizeMinRows]="3"
          [ngClass]="{ 'input-disabled': data.treatment.moment.length > 0 }"
          readonly
          data-test="editTreatment-moment"
        ></textarea>
      </mat-form-field>
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'pointOfAttention' | translate }}</mat-label>

        <textarea
          matInput
          formControlName="pointOfAttention"
          [cdkTextareaAutosize]="true"
          [cdkAutosizeMinRows]="3"
          [ngClass]="{ 'input-disabled': data.treatment.pointOfAttention.length > 0 }"
          readonly
          data-test="editTreatment-pointOfAttention"
        ></textarea>
      </mat-form-field>
    </div>
    <div class="flex--row flex--gutter">
      <div class="flex__child">
        <h3 class="text--h5">{{ 'cropAids' | translate }}</h3>
        @if (cropAidAdvices()?.length) {
          <mat-list
            data-test="editTreatment-products"
            class="layout--margin-negative-horizontal spacing--margin-bottom"
            formArrayName="aidAdvices"
          >
            @for (cropAidAdvice of cropAidAdvices(); track $index) {
              <mat-list-item data-test="editTreatment-productRow">
                <h2 matListItemTitle>
                  {{ cropAidAdvice?.name }}
                  {{ cropAidAdvice?.admissionNumberString }}
                </h2>
                <span matListItemLine
                  >{{ cropAidAdvice?.dosage | agrNumber }} {{ cropAidAdvice?.unitOfMeasurement }}</span
                >
              </mat-list-item>
            }
          </mat-list>
        }
      </div>
    </div>
  </div>
</agr-form-dialog>
